export default seconds => {
  if (seconds === 0) {
    return null
  } else if (seconds < 3600) {
    const minutes = seconds / 60
    const rounded = Math.round(minutes * 10) / 10
    if (rounded === 1) {
      return '1 min'
    } else {
      return `${rounded} mins`
    }
  } else if (seconds < 86400) {
    const hours = seconds / 3600
    const rounded = Math.round(hours * 10) / 10
    if (rounded === 1) {
      return '1 hr'
    } else {
      return `${rounded} hrs`
    }
  } else if (seconds < 604800) {
    const days = seconds / 86400
    const rounded = Math.round(days * 10) / 10
    if (rounded === 1) {
      return '1 day'
    } else {
      return `${rounded} days`
    }
  } else if (seconds < 2628000) {
    const weeks = seconds / 604800
    const rounded = Math.round(weeks * 10) / 10
    if (rounded === 1) {
      return '1 wk'
    } else {
      return `${rounded} wks`
    }
  } else {
    const months = seconds / 2628000
    const rounded = Math.round(months * 10) / 10
    if (rounded === 1) {
      return '1 mo'
    } else {
      return `${rounded} mos`
    }
  }
}